export default import.meta.ROLLDOWN_FILE_URL_pfq3tucsL0bPidwvkDYjtw